export const USER_ID = 'current_user_id';
export const requestOptions = {
    withCredentials: true
}

export const GET_TRANSACTIONS_CALLER_ADVISOR_CODE = "advisor";
export const GET_TRANSACTIONS_CALLER_CLIENT_CODE  = "client";